import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import {qs} from '../../modules/wpstg-dom-utils';

let WPStagingBackupManageSchedules;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupManageSchedules.listen();
  });

  WPStagingBackupManageSchedules = {
    listen() {
      document.body.addEventListener('click', function(event) {
        if (event.target.id === 'wpstg-manage-backup-schedules') {
          WPStagingBackupManageSchedules.manageSchedulesModal();
        }
      });
    },

    manageSchedulesModal() {
      WPStagingBackupManageSchedules.fetchSchedules();
      WPStagingCommon.getSwalModal(false).fire({
        html: document.getElementById('wpstg--modal--backup--manage--schedules').innerHTML,
        showConfirmButton: false,
        showCloseButton: true,
        showLoaderOnConfirm: false,
        showCancelButton: true,
        width: 750,
        allowEscapeKey: true,
        allowOutsideClick: true,
      });
    },
    fetchSchedules() {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups-fetch-schedules',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
          },
          function(response) {
            qs('.wpstg--swal2-container #wpstg--modal--backup--manage--schedules--content').innerHTML = response.data;

            document.querySelectorAll('.wpstg--swal2-container #wpstg--modal--backup--manage--schedules--content .wpstg--dismiss-schedule').forEach(function(dismissButton) {
              dismissButton.addEventListener('click', function(event) {
                WPStagingBackupManageSchedules.dismissSchedule(event.target);
              });
            });
          },
      );
    },
    dismissSchedule(dismissTarget) {
      const scheduleId = dismissTarget.dataset.scheduleId;

      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups-dismiss-schedule',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            scheduleId: scheduleId,
          },
          function(response) {
            if (!response.success) {
              WPStagingCommon.showErrorModal(response.data);
              return;
            } else {
              WPStagingBackupManageSchedules.fetchSchedules();
            }
            console.log(response);
          },
      );
    },
  };
}(jQuery));

export default WPStagingBackupManageSchedules;
